import { IPCEventType } from '@electron/shared/ipc.types';
import { z } from 'zod';

import { ElectronAPI } from '../base/ElectronAPI';

const EventKitListInfoSchema = z.object({
  id: z.string(),
  title: z.string(),
  sourceName: z.string().nullable().optional(),
  colorHex: z.string().nullable().optional(),
  isWritable: z.boolean(),
  isDefault: z.boolean(),
});

const EventKitListInfoListSchema = z.array(EventKitListInfoSchema);

export type EventKitListInfo = z.infer<typeof EventKitListInfoSchema>;

export class EventKitAPI extends ElectronAPI {
  async getReminderLists(): Promise<EventKitListInfo[]> {
    const eventType = IPCEventType.getEventKitReminderLists;
    const response = await this.requestContextKit(eventType);

    if (response?.type === 'error') {
      throw new Error(
        response.info ?? `ContextKit request failed: ${eventType}`
      );
    }

    if (!response?.info) return [];

    return EventKitListInfoListSchema.parse(JSON.parse(response.info));
  }
}
